import React from "react";

// One-shot discovery dialog nudging the user to turn on the notes system.
// Shortened version of Android's notes_system_prompt_body.
const NotesPromptDialog = ({ onTurnOn, onLater }) => {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Notes System</h2>
      <p style={styles.body}>
        Turn on the notes system? You'll be able to take project notes in the
        Notes tab. You can also enable it later from Settings.
      </p>
      <div style={styles.actions}>
        <button style={styles.laterButton} onClick={onLater}>
          Later
        </button>
        <button style={styles.turnOnButton} onClick={onTurnOn}>
          Turn on
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    margin: "0 0 12px",
    fontSize: "20px",
    color: "var(--modal-text)",
  },
  body: {
    margin: "0 0 20px",
    fontSize: "14px",
    lineHeight: "1.5",
    color: "var(--text-muted)",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },
  laterButton: {
    background: "none",
    border: "none",
    color: "var(--text-muted)",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    padding: "8px 12px",
  },
  turnOnButton: {
    backgroundColor: "#234dFF",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    padding: "8px 16px",
  },
};

export default NotesPromptDialog;
